import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import CustomSelect from "../../Components/CustomSelect";
import { ClipLoader } from "react-spinners";
import { TYPE_OPTIONS } from "services/constants";
import localization from "services/localization";
import IconPicker from "views/Components/IconPicker";

const AddEditModuleModal = ({
  show,
  title,
  formData,
  errors,
  onChange,
  onSubmit,
  onClose,
  loading,
  onFormChange,
}) => {
  const [type, setType] = useState(null);

  useEffect(() => {
    if (formData?.type) {
      const selected = TYPE_OPTIONS.find((t) => t.value === formData.type);
      setType(selected || null);
    }
  }, [formData]);

  const handleSelectChange = (field, selectedOption) => {
    setType(selectedOption);
    onChange({
      target: { name: field, value: selectedOption?.value || "" },
    });
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="md"
      className="themed-modal addEditModal"
      enforceFocus={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Form onSubmit={onSubmit}>
        <Modal.Body>
          <Row>
            {/* Module Name */}
            <Col md={12} className="mb-3">
              <Form.Group className="required">
                <Form.Label className="bootstrap-label">
                  {localization.module_name || "Module Name"}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name || ""}
                  onChange={onChange}
                  placeholder={
                    localization.enter_module_name || "Enter module name"
                  }
                  isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* Module Type */}
            <Col md={12} className="mb-3">
              <Form.Group className="required">
                <Form.Label className="bootstrap-label">
                  {localization.type || "Type"}
                </Form.Label>
                <CustomSelect
                  options={TYPE_OPTIONS}
                  value={type}
                  onChange={(val) => handleSelectChange("type", val)}
                  placeholder={localization.select_type || "Select type"}
                />
                {errors.type && (
                  <div className="text-danger small mt-1">{errors.type}</div>
                )}
              </Form.Group>
            </Col>

            {/* Description */}
            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="bootstrap-label">
                  {localization.description || "Description"}
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  name="description"
                  value={formData.description || ""}
                  onChange={onChange}
                  placeholder={
                    localization.enter_module_description ||
                    "Enter module description"
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group>
                <Form.Label className="bootstrap-label">
                  {localization.icon || "Icon"}
                </Form.Label>
                <IconPicker
                  value={formData.icon}
                  onChange={(value) => onFormChange("icon", value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button className="action-btn secondary" onClick={onClose}>
            {localization.cancel || "Cancel"}
          </Button>
          <Button
            className="action-btn primary no-border"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <ClipLoader color="var(--primary-icon)" size={20} />
            ) : (
              localization.save || "Save"
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddEditModuleModal;
